export default __webpack_public_path__ + "static/media/mobile-rainbow+bfs.c80908af.svg";